// extracted by mini-css-extract-plugin
export default {"container":"tz-z","dimension":"uz-z","dimensionLabels":"vz-z"};